import gql from 'graphql-tag'

export const DELETE_PROSPECT_RECEIVED_FAVORITES = gql`
  mutation deleteProspectReceivedLink(
    $senderProspectId: Int!
    $receiverProspectId: Int!
    $clientId: Int!
  ) {
    deleteProspectReceivedLink(
      senderProspectId: $senderProspectId
      receiverProspectId: $receiverProspectId
      clientId: $clientId
    )
  }
`
